module.exports = __webpack_public_path__ + "assets/img/app.d18b00fe.png";